import { styled } from '@pata-app/themes';

export const FeatureSectionContainer = styled.div<{ $rightAligned?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 70px;

  max-width: 1200px;
  margin: auto;

  /* padding: ${({ $rightAligned }) => ($rightAligned ? '70px 0' : '0')}; */

  img {
    width: 100%;

    object-fit: cover;

    border-radius: ${({ theme }) => theme.core.border.element.radius}px;
  }

  @media ${({ theme }) => `${theme.core.breakpoints.l}`} {
    flex-direction: ${({ $rightAligned }) => ($rightAligned ? 'row' : 'row-reverse')};

    img {
      width: 400px;
      min-width: 400px;
    }
  }
`;

export const SectionTitle = styled.h3`
  font-size: ${({ theme }) => theme.core.fontSizes.xxl}px;

  margin-top: 0;

  color: ${({ theme }) => theme.core.colors.primary.green.medium};
`;

export const FeaturesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: ${({ theme }) => theme.core.sizing[3]}px;

  @media ${({ theme }) => `${theme.core.breakpoints.s}`} {
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  }
`;

export const FeatureContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.core.sizing[2]}px;

  p {
    margin: 0;
  }

  button {
    max-width: 150px;
  }
`;

export const SectionHeading = styled.h2`
  font-size: ${({ theme }) => theme.core.fontSizes.xxxl}px;
  text-align: center;

  margin-top: 70px;
`;

export const CalloutContainer = styled.div`
  width: 100%;
  padding: ${({ theme }) => theme.core.sizing[2]}px;

  border-radius: ${({ theme }) => theme.core.border.element.radius}px;

  border: 0.5px solid ${({ theme }) => theme.core.colors.primary.teal.medium};
  border-left: 8px solid ${({ theme }) => theme.core.colors.primary.teal.medium};

  margin-top: 32px;

  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08), 0 2px 4px rgba(0, 0, 0, 0.04);

  color: ${({ theme }) => theme.core.colors.primary.green.medium};
  font-size: ${({ theme }) => theme.core.fontSizes.l}px;
  font-weight: 600;
  line-height: 1.3;
  text-align: left;
`;
